<template>
  <v-dialog
    v-model="show"
    :max-width="options.maxWidth"
    :transition="transition"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
  >

    <v-card
    >

      <v-toolbar
        dark
        color="primary"
        column
        flat
        style="border-bottom: 1px solid #f5f5f5; background-color:white; margin:0px; padding:0px;"
      >

        <v-toolbar-title>Confirm Assignment</v-toolbar-title>

      </v-toolbar>


      <v-card-text v-if="this.options.payload">
        You are about to assign this document to the following patient: {{this.options.payload.patientDisplayString}}

      </v-card-text>

      <!-- Actions -->
      <v-spacer></v-spacer>

      <v-card-actions>

        <v-btn
          depressed
          @click="cancel"
        >Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="confirmAssignment()"
          depressed
        >Confirm</v-btn>

      </v-card-actions>

    </v-card>

  </v-dialog>
</template>

<style scoped>
.card > .card__actions {
  flex: none;
}

.card__actions .btn {
  text-transform: capitalize;
}

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: white;
}

.content {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  text-align: center;
  color: #52535f;
}

.sharingLink {
  font-size: 24px;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 20px;
  text-align: center;
  color: #52535f;
  word-wrap: break-word;
}
</style>

<script>
import DialogMixin from '@/core/mixins/DialogMixin'
import HelperMixin from '@/core/mixins/HelperMixin'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'RequestDialog',
  mixins: [DialogMixin, HelperMixin],
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions('provider', [
      'search',
      'getProviderIDFromNPI',
      'multipleShareFiles',
      'getProviderAuth'
    ]),
    ...mapActions('admin', ['getPatient', 'fuzzySearchForPatient', 'setRequestToComplete']),
    confirmAssignment() {
      this.$emit('confirmedAssignmentEmit', this.options.payload)
      this.cancel()
    }
  },
  watch: {
  },
  computed: {
    ...mapState('auth', ['currentUserGroups']),
    ...mapState('admin', ['patientSearchResults'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/ConfirmAssignmentDialog.vue